var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWidgetTreeMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.25 5.5H13.5v7h1.75a.75.75 0 0 1 0 1.5h-2c-.69 0-1.25-.56-1.25-1.25V10H9.75a.75.75 0 0 1 0-1.5H12V5.25c0-.69.56-1.25 1.25-1.25h2a.75.75 0 0 1 0 1.5zm-12-.5C2.56 5 2 5.56 2 6.25v6c0 .69.56 1.25 1.25 1.25h3.5c.69 0 1.25-.56 1.25-1.25v-6C8 5.56 7.44 5 6.75 5h-3.5zm.25 7V6.5h3V12h-3z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetTreeMap);
export default __webpack_public_path__ + "static/media/widgetTreeMap.38bad39f1463e4da91c623eeeb94404a.svg";
export { ForwardRef as ReactComponent };